import { render, staticRenderFns } from "./TreeTagText.vue?vue&type=template&id=a0e7fb24&scoped=true&"
import script from "./TreeTagText.vue?vue&type=script&lang=js&"
export * from "./TreeTagText.vue?vue&type=script&lang=js&"
import style0 from "./TreeTagText.vue?vue&type=style&index=0&id=a0e7fb24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e7fb24",
  null
  
)

export default component.exports